import { useState } from 'react';
import { Carousel, Image } from 'antd';
import animalsRange from '../../../assets/images/vet-animals-range.jpg';
import companionCare from '../../../assets/images/vet-companion-care1.jpg';
import productRange from '../../../assets/images/vet-product-range1.jpg';
import clinicSpecies from '../../../assets/images/vet-clinic-species1.jpg';
import homeCare from '../../../assets/images/vet-home-care.jpg';

const SLIDES = [
    { src: animalsRange, alt: 'Livestock, poultry and companion animal health products' },
    { src: companionCare, alt: 'Caring for companion animals' },
    { src: productRange, alt: 'Veterinary medicine and supplement range' },
    {
        src: clinicSpecies,
        alt: 'A veterinarian caring for farm and companion animals - horse, cattle, sheep, dog, cat, rabbit, bird and reptile',
    },
    {
        src: homeCare,
        alt: 'Pets at home with feed, medicines and first-aid supplies',
    },
];

function Slider() {

    const [allImages] = useState(SLIDES);

    return (
        <>
            {/* Full width, flush under the nav. It used to sit in a
                col-lg-11 offset-lg-1 inside a col-md-8, with a 1.5rem top
                margin and a fixed 570px height - hence the band of empty
                space above it and the gap down the left. */}
            <div className='homeSlider'>
                <Carousel autoplay autoplaySpeed={2500}>
                    {allImages.map((item, index) => (
                        <div className='homeSlide' key={index}>
                            <Image
                                src={item.src}
                                alt={item.alt}
                                preview={false}
                                rootClassName='homeSlideImage'
                                className='homeSlideImg'
                            />
                        </div>
                    ))}
                </Carousel>
            </div>
        </>
    )
}
export default Slider;
